import { X } from "lucide-react";

import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/Modal";
import StatusBadge from "@/components/shared/StatusBadge";
import { Screenshots } from "@/components/feedback/Screenshot";
import { FEEDBACK_STATUS_COLOR as STATUS_COLOR } from "@/config/dropdownData";
import { FeedbackService } from "@/services/feedbackService";
import { formatDate } from "@/utils/dateUtils";

import StatusHistory from "./StatusHistory";

const FeedbackDetailModal = ({ feedback, typeLabel, statusLabel, onClose }) => (
  <Dialog open onOpenChange={(o) => !o && onClose?.()}>
    <DialogContent className="w-[340px] md:w-[640px] flex flex-col">
      <DialogHeader className="relative pl-5 pr-14 py-3 border-b border-border-primary shrink-0">
        <DialogTitle className="text-[15px] font-semibold text-text-primary">
          {typeLabel} · {feedback.tenant_name || "Unknown tenant"}
        </DialogTitle>
        <DialogDescription className="text-[12px] text-text-secondary">
          Received {formatDate(feedback.created_at)}
          {feedback.is_imported && " · Imported"}
        </DialogDescription>
        <DialogClose aria-label="Close" className="absolute right-4 top-3 w-7 h-7 rounded-full bg-background-icon/40 flex items-center justify-center">
          <X size={16} strokeWidth={3} />
        </DialogClose>
      </DialogHeader>

      <div className="px-5 py-4 space-y-4 max-h-[70vh] overflow-y-auto">
        <section aria-labelledby="feedback-comment-heading" className="space-y-2">
          <div className="flex items-center justify-between gap-3">
            <h3 id="feedback-comment-heading" className="text-sm font-semibold text-text-primary">
              Comment
            </h3>
            {/* None for Appreciation, which is never worked. */}
            {feedback.status && <StatusBadge text={statusLabel} colorIndex={STATUS_COLOR[feedback.status] ?? 0} size="sm" />}
          </div>
          <p className="whitespace-pre-wrap break-words text-sm text-text-primary">{feedback.comment}</p>
        </section>

        <Screenshots feedback={feedback} fetchImage={FeedbackService.fetchImage} />

        <section aria-labelledby="feedback-history-heading" className="space-y-2 border-t border-border-primary pt-4">
          <h3 id="feedback-history-heading" className="text-sm font-semibold text-text-primary">
            Status history
          </h3>
          <StatusHistory feedbackId={feedback.id} status={feedback.status} />
        </section>
      </div>
    </DialogContent>
  </Dialog>
);

export default FeedbackDetailModal;
